import Cookies from "js-cookie";
import { useEffect, useState } from "react";

export function useCookies(name: string) {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    performSetCookies();

    const intervalId = setInterval(() => {
      performSetCookies();
    }, 500);

    return () => {
      clearInterval(intervalId);
    };

    // eslint-disable-next-line
  }, []);

  function performSetCookies() {
    const cookiesValue = Cookies.get(name);

    if (!cookiesValue) setValue(null);
    else setValue(cookiesValue);
  }

  return value;
}

// https://stackoverflow.com/questions/4713019/setting-cross-subdomain-cookie-with-javascript
export function getDomain() {
  const matches = location.hostname.match(/[^\.]*\.[^.]*$/);

  // for localhost
  if (!matches) return location.hostname + ";";

  return matches[0] + ";";
}
